
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)","fill":"currentColor"}},[_c('path',{attrs:{"d":"M23.034 0H.966A.966.966 0 000 .966v22.067c0 .534.433.967.966.967h22.067a.966.966 0 00.967-.966V.966A.966.966 0 0023.034 0zm-.967 22.067H1.933V1.933h20.134v20.134z"}}),_c('path',{attrs:{"d":"M23.066 8.727H.966v1.933h22.1V8.727z"}}),_c('path',{attrs:{"d":"M7.636 0v9.818h1.637V0H7.636zM15.273 0v9.818h1.636V0h-1.636z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    